import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import ButtonMaterial from './ButtonMaterial';
import ButtonAnt from './ButtonAnt';
import { useComponentLibrary } from '../../FormRenderCtx';

const ButtonUI = forwardRef(function ButtonUI(props, ref) {
  const { tooltip, ...rest } = props;

  const componentLibrary = useComponentLibrary();

  const Comp =
    {
      'material-ui': ButtonMaterial,
      'ant-design': ButtonAnt,
    }[componentLibrary] || ButtonAnt;

  if (!tooltip) {
    return <Comp {...rest} ref={ref} />;
  }

  return (
    <Tooltip {...tooltip}>
      <Comp {...rest} ref={ref} />
    </Tooltip>
  );
});

ButtonUI.propTypes = {
  tooltip: PropTypes.shape({}),
};

export default ButtonUI;
